/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Physics13Inputs */

const en__field__enum_studyprograms_study_physics13 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Physics13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physics`)
};

const de__field__enum_studyprograms_study_physics13 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Physics13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Physik`)
};

/**
* | output |
* | --- |
* | "Physics" |
*
* @param {_Field__Enum_Studyprograms_Study_Physics13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_physics13 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Physics13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Physics13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_physics13(inputs)
	return de__field__enum_studyprograms_study_physics13(inputs)
});
export { _field__enum_studyprograms_study_physics13 as "_field__enum_studyPrograms_STUDY_PHYSICS" }